// The one deadline every boat-authoritative control waits on.
//
// Both relay slices on this page work the same way: the cloud relays an
// instruction DOWN, writes nothing itself, and waits for the boat's own echo to
// come back through the mirror (ADR 0173 for the vessel type, ADR 0174 for the
// pause). Neither can honestly say "saved" on a click, so both need a moment at
// which they stop saying "on its way" too — otherwise a command that silently
// warn-dropped on an old core leaves a spinner-shaped claim on the page for as
// long as the tab is open.
//
// It lives here, once, rather than in each module. Two controls disagreeing
// about how long a boat gets would be an arbitrary difference an owner could
// notice — "the pause gave up but the boat type is still trying" — with nothing
// behind it, and the value is a property of the ROUND TRIP, not of either
// setting.

/**
 * How long a page waits for the boat's echo before it stops claiming the
 * command is still in flight.
 *
 * Generous on purpose: this covers the relay, the boat's own write, its outbox
 * drain and the cloud ingest, and a boat on a marina connection is not fast.
 * Erring long is the safe direction — the failure of erring short is telling an
 * owner their command did not land when it did.
 */
export const BOAT_ECHO_TIMEOUT_MS = 45_000;
